/* eslint-disable no-param-reassign */
import React, { useContext, useEffect, useMemo } from 'react';
import { Card } from 'react-bootstrap';

import useErrorState, { translateError } from 'utils/hooks/useErrorState';
import { Ctx } from 'components/CtxFormFields/CtxInputs';
import RenderFormItem from 'components/CtxFormFields/FormFieldCtx';

import { defaultOptions, junctionFields } from './formSchema';

function Junction() {
  const formContext = useContext<{
    values: {
      integrationState: { [key: string]: any };
      setEnabledSave: (arg0: boolean) => void;
    };
    onChange: (arg0: any) => void;
  }>(Ctx as any);
  const { integrationState, setEnabledSave } = formContext.values as {
    integrationState: { [key: string]: any };
    setEnabledSave: (arg0: boolean) => void;
  };

  const { provider, msConfig, logging } = junctionFields;
  const {
    errors,
    hasErrors,
  }: { errors: { [key: string]: string }; hasErrors: boolean } = useErrorState(
    integrationState,
    {
      ...provider,
      ...msConfig,
      ...logging,
    },
  );

  // If there are errors disable update button
  useEffect(() => {
    setEnabledSave(!hasErrors);
  }, [hasErrors]);

  // Update configuration fields
  const onChange = (key: string, value: string) => {
    let newVal;
    switch (key) {
      case 'Port':
      case 'apiPort':
        newVal = Number(value.replace(/\D/g, ''));
        break;
      default:
        newVal = String(value);
        break;
    }

    formContext.onChange({ [key]: newVal });
  };

  return (
    <div className="d-flex flex-column flex-fill">
      <Ctx.Provider
        // @ts-ignore
        value={useMemo(
          () => ({
            values: { ...defaultOptions, ...integrationState },
            onChange: onChange as any,
          }),
          [defaultOptions, integrationState, onChange],
        )}
      >
        <Card className="my-3">
          <Card.Header>Junction Integration Form</Card.Header>
          <Card.Body>
            {Object.values(provider).map(({ validate, ...rest }) => (
              <RenderFormItem
                key={rest.id}
                name={rest.id}
                error={translateError(errors[rest.id])}
                {...rest}
              />
            ))}
          </Card.Body>
        </Card>
        <Card className="my-3">
          <Card.Header>Integration provider settings</Card.Header>
          <Card.Body>
            {Object.values(logging).map(({ validate, ...rest }) => (
              <RenderFormItem
                key={rest.id}
                name={rest.id}
                error={translateError(errors[rest.id])}
                {...rest}
              />
            ))}
          </Card.Body>
        </Card>
      </Ctx.Provider>
    </div>
  );
}

export default Junction;
